import { Currency, ETHER, Token, ChainId } from '@uniswap/sdk'

export function currencyId(currency: Currency, chainId?: ChainId): string {
  if (currency === ETHER) {
    // 根据链ID返回不同的符号
    if (chainId === ChainId.BSC) {
      return 'BNB'
    }
    return process.env.REACT_APP_NATIVE_CURRENCY_SYMBOL ?? 'K'
  }
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
